<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0">
            <v-layout row wrap>
              <v-flex xs10>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="mdi-account-search-outline"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search project name':'Search'"
                single-line
                hide-details
                v-model="search"
                @input="searchProjectTitle(search)"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs2 class="text-right pt-4">
                <v-chip :class="isClosedProject ? 'info dark' : '' " @click="showClosedProjects()">Show Closed Projects</v-chip>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-expansion-panels v-if="projTitle.length > 0" :value="selTab">
              <v-expansion-panel v-for="(proj, i) in projTitle" :key="i">
                <v-expansion-panel-header class="py-0">
                  <div class="subtitle">{{ proj }}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                  :headers="projBillHead"
                  hide-default-header
                  :items="projBillingList.filter(rec => rec.proj_name === proj)"
                  hide-default-footer
                  disable-pagination
                  :mobile-breakpoint="0"
                  class="elevation-1"
                  dense>
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[0].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 90px; text-align: left;">{{headers[1].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 110px; text-align: left;">{{headers[2].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 110px; text-align: left;">{{headers[3].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 110px; text-align: right;">{{headers[4].text}}</th>
                      </tr>
                    </thead>
                  </template>
                  <template slot="item" slot-scope="props">
                    <tr @click="prepareUpdate(props.item)" :class="props.item.proj_status === 'Closed' ? 'grey--text' : ''">
                      <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                      <td style="font-size: 12px;">{{ props.item.billing_month_year }}</td>
                      <td style="font-size: 12px;">{{ handy.formatDate(props.item.billing_start_date) }}</td>
                      <td style="font-size: 12px;">{{ handy.formatDate(props.item.billing_end_date) }}</td>
                      <td style="font-size: 12px; text-align: right;">{{ handy.formatCur(props.item.approved_billed_amt) }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-flex xs12 v-else>
            <div style="font-size: 15px; text-align: center; color: #FFAB40;">
              No active project Billing
            </div>
          </v-flex>
        </v-card-text>
      </v-card>

      <!-- 1. create, update and delete of project contract -->
      <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
        <v-layout row wrap>
          <v-flex xs12 class="mt-2">
            <v-form ref="pForm" @submit.prevent="saveProjectBillingBaseChanges(lAction)">
              <v-card>
                <v-card-title class="py-2 grey lighten-4">
                  <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                  <span class="pl-2 primary--text">{{ handy.startWithUpper(lAction) + ' Project Billing' }}</span>
                </v-card-title>
                <v-card-text>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs3>
                        <v-combobox
                        v-model="lProjBillingBase.proj_billing_base_pair"
                        :items="projContractList"
                        item-text="proj_name"
                        item-value="proj_contract_base_id"
                        label="Project"
                        hide-details
                        :disabled="lAction === 'update'"
                        ></v-combobox>
                      </v-flex>
                      <v-flex xs2>
                        <v-dialog ref="dlgBillingMon"
                        persistent v-model="dlgBillingMon"
                        max-width="290px"
                        :return-value.sync="lProjBillingBase.billing_monthAndYear"
                        >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="Billing Month &amp; Year"
                          :rules="[rules.required]"
                          v-model="lProjBillingBase.billing_monthAndYear" append-icon="mdi-calendar-today"
                          readonly clearable hide-details
                          v-on="on" :disabled="lAction === 'update'"
                          ></v-text-field>
                        </template>
                        <v-date-picker type="month" :disabled="lAction === 'update'"
                        @input="basedOnSelectedMonthShowStartingAndEndingDate(lProjBillingBase.billing_monthAndYear)"
                        v-model="lProjBillingBase.billing_monthAndYear" scrollable
                        first-day-of-week="1"
                        >
                        <v-spacer></v-spacer>
                        <v-btn text @click="dlgBillingMon = false">Cancel</v-btn>
                        <v-btn text color="accent" @click="$refs.dlgBillingMon.save(lProjBillingBase.billing_monthAndYear)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs2>
                    <v-dialog ref="dlgBillingStartDate"
                    persistent v-model="dlgBillingStartDate"
                    max-width="290px"
                    :return-value.sync="lProjBillingBase.billing_start_date"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator" label="Billing Start Date"
                      :rules="[rules.required]"
                      v-model="lProjBillingBase.billing_start_date" append-icon="mdi-calendar-today"
                      readonly clearable hide-details
                      v-on="on" :disabled="projBillingDetList.length > 0"
                      ></v-text-field>
                    </template>
                    <v-date-picker :disabled="projBillingDetList.length > 0"
                      v-model="lProjBillingBase.billing_start_date" scrollable
                      :min="handy.formatDBDate(fromDate)"
                      :max="handy.formatDBDate(toDate)"
                      @input="loadEndDateBasedOnStartingDate(lProjBillingBase.billing_start_date)"
                      first-day-of-week="1">
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgBillingStartDate = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgBillingStartDate.save(lProjBillingBase.billing_start_date)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs2>
                  <v-dialog ref="dlgBillingEndDate"
                  persistent v-model="dlgBillingEndDate"
                  max-width="290px"
                  :return-value.sync="lProjBillingBase.billing_end_date"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Billing End Date"
                    :rules="[rules.required]"
                    v-model="lProjBillingBase.billing_end_date" append-icon="mdi-calendar-today"
                    readonly clearable hide-details
                    v-on="on" :disabled="projBillingDetList.length > 0"
                    ></v-text-field>
                  </template>
                  <v-date-picker :disabled="projBillingDetList.length > 0"
                    v-model="lProjBillingBase.billing_end_date" scrollable
                    :min="handy.formatDBDate(fromDate)"
                    :max="handy.formatDBDate(toDate)"
                    first-day-of-week="1"
                    >
                    <v-spacer></v-spacer>
                    <v-btn text @click="dlgBillingEndDate = false">Cancel</v-btn>
                    <v-btn text color="accent" @click="$refs.dlgBillingEndDate.save(lProjBillingBase.billing_end_date)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs3 class="text-right pt-4">
                <v-btn class="mr-3" :disabled="isClosedProject" @click="deleteProjectBilling(lProjBillingBase)" v-if="projBillingDetList.length === 0 && lAction === 'update' && (config.IS_EDITED_BY_USER)">delete</v-btn>
                <v-btn class="accent" type="submit" v-if="(config.IS_EDITED_BY_USER)" :disabled="isClosedProject || projBillingDetList.length > 0">save</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-form>
  </v-flex>
  <v-flex xs12 v-if="lProjBillingBase.proj_billing_base_id">
    <v-card>
      <v-card-title class="py-2 pl-2 grey lighten-4">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs5 class="text-center">
              <span style="color: #000; font-size: 12px; font-weight:bold;">Current Status:  </span>
              <v-chip :disabled="isClosedProject" style="font-weight:bold;" small color="tertiary white--text">{{lStatus}}</v-chip>
              <span class="ml-3" style="color: #000; font-size: 12px; font-weight:bold;">Selected Bill No.:  </span>
              <v-chip :disabled="isClosedProject" style="font-weight:bold;" small color="green white--text">{{'Bill # ' + lBillNo}}</v-chip>
            </v-flex>
            <v-flex xs7 class="text-right">
              <v-btn style="font-size: 10px;" class="mr-2" v-if="(config.IS_EDITED_BY_USER)" :disabled="(config.ROLE_NAME != 'Super Admin' && lStatus !== 'Draft') || isClosedProject" @click="prepareServiceDet(lProjBillingBase.proj_billing_base_id)">Add Services</v-btn>
              <v-btn style="font-size: 10px;" class="mr-2" v-if="(config.IS_EDITED_BY_USER)" :disabled="(config.ROLE_NAME != 'Super Admin' && lStatus !== 'Draft') || isClosedProject" @click="prepareStaffDet(lProjBillingBase.proj_billing_base_pair.proj_contract_base_id)">Add Roles</v-btn>
              <v-btn style="font-size: 10px;" class="mr-2" v-if="(config.IS_EDITED_BY_USER)" :disabled="isClosedProject" @click="prepareNewBill(lProjBillingBase)">Add New Bill</v-btn>
              <v-btn style="font-size: 9px;" color="green white--text" @click="prepareViewProjContract(lProjBillingBase.proj_billing_base_pair.proj_contract_base_id)">View Proj Contract</v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="ml-2" @click="loadBillingComparison()" fab small><v-icon>mdi-compare-vertical</v-icon></v-btn>
                </template>
                <span>Comparision</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-card-text class="pa-1">
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs12 sm9 class="pa-0">
              <v-flex xs12>
                <v-data-table
                :headers="detHeaders"
                :items="projBillingDetList"
                hide-default-footer
                disable-sort
                fixed-header
                dense
                class="elevation-1"
                height="310px"
                disable-pagination
                >
                <template slot="item" slot-scope="props">
                  <v-menu
                  absolute
                  offset-y
                  >
                  <template v-slot:activator="{ on }">
                    <tr v-on="on">
                      <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                      <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
                      <td style="font-size: 12px; text-align: center;">{{ props.item.head_count }}</td>
                      <td style="font-size: 12px; text-align: center;">{{ props.item.billing_cycle }}</td>
                      <td style="font-size: 12px; text-align: center;">{{ props.item.present_days }}</td>
                      <td style="font-size: 12px; text-align: center;">{{ props.item.wo }}</td>
                      <td style="font-size: 12px; text-align: center;">{{ props.item.holidays }}</td>
                      <td style="font-size: 12px; text-align: center;">{{ props.item.tot_days_worked }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.chargeable_amt) }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.billed_amt) }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.Mgmt_fee_amt) }}</td>
                      <td style="font-size: 12px;" class="text-right">{{ handy.formatCur(props.item.gst_amt) }}</td>
                    </tr>
                  </template>
                  <!-- list of menuitems -->
                  <v-list v-if="(config.IS_EDITED_BY_USER)">
                    <v-list-item v-if="props.item.proj_billing_service_det_id" :disabled="isClosedProject || (lStatus !== 'Draft' && config.ROLE_NAME != 'Super Admin')" @click="prepareUpdateServiceProjBillingDet(props.item)">
                      <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus !== 'Draft' && config.ROLE_NAME != 'Super Admin')">mdi-pencil</v-icon></v-list-item-avatar>
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="props.item.proj_billing_staff_det_id" :disabled="isClosedProject || (lStatus !== 'Draft' && config.ROLE_NAME != 'Super Admin')" @click="prepareUpdateProjBillingDet(props.item)">
                      <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus !== 'Draft' && config.ROLE_NAME != 'Super Admin')">mdi-pencil</v-icon></v-list-item-avatar>
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="isClosedProject || (lStatus !== 'Draft' && config.ROLE_NAME != 'Super Admin')" @click="deleteDetail(props.item)">
                      <v-list-item-avatar><v-icon :disabled="isClosedProject || (lStatus !== 'Draft' && config.ROLE_NAME != 'Super Admin')">mdi-delete</v-icon></v-list-item-avatar>
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
              <template slot="body.append">
                <tr class="orange lighten-3">
                  <td colspan="8">
                    <strong>Total</strong>
                  </td>
                  <td :class="totalBillingAmt.tot_chargeable_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                    <strong>{{ handy.formatCur(totalBillingAmt.tot_chargeable_amt) }}</strong>
                  </td>
                  <td :class="totalBillingAmt.tot_billed_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                    <strong>{{ handy.formatCur(totalBillingAmt.tot_billed_amt) }}</strong>
                  </td>
                  <td :class="totalBillingAmt.mgmt_fee_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                    <strong>{{ handy.formatCur(totalBillingAmt.mgmt_fee_amt) }}</strong>
                  </td>
                  <td :class="totalBillingAmt.gst_amt === 0 ? 'text-right' : 'pl-0 text-right'">
                    <strong>{{ handy.formatCur(totalBillingAmt.gst_amt) }}</strong>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-flex>
        <v-flex xs12 sm3 class="pt-0 pr-0 pl-2">
          <v-data-table
          :headers="billDetHistory"
          :items="billNoList"
          hide-default-footer
          disable-sort
          disable-pagination
          dense
          fixed-header
          height="310px"
          class="elevation-1"
          :mobile-break-point="0">
          <template slot="item" slot-scope="props">
            <tr @click="loadBillingDetailsBasedOnBillNo(props.item)" :class="lBillNo === props.item.bill_no ? 'warning lighten-5' : 'tertiary--text'" style="font-weight: bold; cursor: pointer;">
              <td style="font-size: 12px; padding:7px 8px;">{{ props.item.bill_no }} <span :class="props.item.billing_status === 'Submitted' ? 'orange--text' : props.item.billing_status === 'Approved' ? 'green--text' : 'red--text'">{{'(' + props.item.billing_status + ')'}}</span></td>
              <td style="font-size: 12px; padding:7px 8px;">{{ handy.formatCur(props.item.tot_billed_amt) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-flex>
  <v-flex xs12>
    <v-layout row wrap>
      <v-flex xs9>
        <v-alert border="top" colored-border color="info" elevation="2" class="grey lighten-4 mb-0">
          <v-flex xs12>
            <table width="100%" cellpadding="0" cellspacing="0">
              <tr>
                <td class="subheading" style="width: 190px;">
                  <v-chip small :disabled="isClosedProject" style="background-color:#4EA9D0; font-size: 12px; color:#fff;">Manpower Total : &nbsp;<span style="font-weight: bold;">{{ handy.formatCur(totalBillingAmt.total_man_cost) || 0 }}</span></v-chip>
                </td>
                <td class="subheading pl-1" colspan="100%">
                  <v-chip small :disabled="isClosedProject" style="background-color:#4EA9D0; font-size: 12px; color:#fff;">Service Total : &nbsp;<span style="font-weight: bold;">{{ handy.formatCur(totalBillingAmt.total_ser_cost) || 0 }}</span></v-chip>
                </td>
              </tr>
            </table>
          </v-flex>
        </v-alert>
        <v-alert border="top" colored-border color="info" elevation="2" class="grey lighten-4 mt-2 mb-0">
          <v-layout row wrap>
            <v-flex xs6 class="pt-0">
              <v-alert text dense class="grey lighten-4 pl-1">
                <v-layout row wrap>
                  <v-flex xs1>
                    <v-btn style="height: 0px;" @click="showTimelineInfo = true" icon><v-icon>mdi-information-outline</v-icon></v-btn>
                  </v-flex>
                  <v-flex xs11>
                    <div style="font-size: 12px; color: #000;" v-if="lAction === 'update'">Created By: {{lProjBilling.created_by}} on {{handy.formatDate(lProjBilling.created_date) + ' ' + handy.getTime12Hrs(lProjBilling.created_date)}}</div>
                    <div style="font-size: 12px; color: #000;" v-if="lAction === 'update' && lProjBilling.update_by">Updated By: {{lProjBilling.update_by}} on {{handy.formatDate(lProjBilling.updated_date) + ' ' + handy.getTime12Hrs(lProjBilling.updated_date)}}</div>
                    <div style="font-size: 12px; color: #000;" v-if="lStatus === 'Submitted' || lStatus === 'Approved'">Submitted By: {{lProjBilling.submitted_by_name}} on {{handy.formatDate(lProjBilling.submitted_date) + ' ' + handy.getTime12Hrs(lProjBilling.submitted_date)}}</div>
                    <div style="font-size: 12px; color: #000;" v-if="lStatus === 'Approved'">Approved By: {{lProjBilling.approved_by}} on {{handy.formatDate(lProjBilling.approved_date) + ' ' + handy.getTime12Hrs(lProjBilling.approved_date)}}</div>
                    <div style="font-size: 12px; color: #000;" v-if="lStatus === 'Draft' && lProjBilling.submitted_by_name && lProjBilling.rejected_date">Rejected By: {{lProjBilling.rejected_by_name}} on {{handy.formatDate(lProjBilling.rejected_date) + ' ' + handy.getTime12Hrs(lProjBilling.rejected_date)}}</div>
                    <div style="font-size: 12px; color: #000;" v-if="lStatus === 'Draft' && lProjBilling.drafted_by_name && lProjBilling.drafted_date">Drafted By Super Admin: {{lProjBilling.drafted_by_name}} on {{handy.formatDate(lProjBilling.drafted_date) + ' ' + handy.getTime12Hrs(lProjBilling.drafted_date)}}</div>
                  </v-flex>
                </v-layout>
              </v-alert>
            </v-flex>
            <v-flex xs6 class="text-right pr-0 pt-0">
              <v-btn class="ml-2" small :disabled="isClosedProject" v-if="lStatus === 'Submitted' && (config.IS_EDITED_BY_USER)" @click="prepareProjectBillingStatus(lProjBillingBase, 'Approved')">Approve</v-btn>
              <v-btn class="ml-2" small :disabled="isClosedProject" v-if="lStatus === 'Submitted' && (config.IS_EDITED_BY_USER)" @click="prepareProjectBillingStatus(lProjBillingBase, 'Rejected')">Reject</v-btn>
              <v-btn class="ml-2" small :disabled="projBillingDetList.length === 0 || isClosedProject" v-if="lStatus === 'Draft' && (config.IS_EDITED_BY_USER)" @click="prepareProjectBillingStatus(lProjBillingBase, 'Submitted')">submit</v-btn>
              <v-btn class="ml-2" small :disabled="isClosedProject" v-if="(lStatus === 'Approved' || lStatus === 'Obsolete Approved') && (config.IS_EDITED_BY_USER)" @click="prepareRevision(lProjBillingBase)">create revision</v-btn>
              <v-btn class="ml-2" small :disabled="isClosedProject" v-if="(lStatus === 'Approved' || lStatus === 'Obsolete Approved') && config.ROLE_NAME === 'Super Admin' && (config.IS_EDITED_BY_USER)" @click="prepareProjectBillingStatus(lProjBillingBase, 'Draft')">convert as draft</v-btn>
              <v-btn small class="ml-2" :disabled="projBillingDetList.length === 0" @click="prepareViewProjBilling(lProjBillingBase)">view</v-btn>
            </v-flex>
          </v-layout>
        </v-alert>
      </v-flex>
      <v-flex xs3>
        <v-flex :disabled="isClosedProject" style="font-weight:bold; height: 40px; font-size: 13px;" small class="tertiary white--text text-center pt-2 ml-2">Total Approved Amount: {{handy.formatCur(lProjBilling.approved_billed_amt)}}</v-flex>
      </v-flex>
    </v-layout>
  </v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-layout>
</v-container>

<!-- 2. Add Role -->
<v-dialog v-model="showListOfProjContractDet" persistent scrollable max-width="500px">
  <v-card>
    <v-card-title class="py-2 grey lighten-4">
      Select Roles
      <v-spacer></v-spacer>
      <v-btn icon small @click="showListOfProjContractDet = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-data-table
      v-model="selected"
      show-select
      :headers="projContractHeadList"
      :items="projContractDetList"
      hide-default-footer
      disable-sort
      disable-pagination
      dense
      item-key="staff_role"
      class="elevation-1"
      :mobile-break-point="0">
    </v-data-table>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn class="accent" :disabled="beingSaved" @click="importToProjectBilling(selected)">Import to Bill # {{lBillNo}}</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- 3. Updating Project billing detail -->
<v-dialog v-model="showEditProjectBillingDet" persistent scrollable max-width="500px">
  <v-card>
    <v-card-title class="py-2 grey lighten-4">
      Update {{lProjBillingDet.staff_role}} Billing Details
    </v-card-title>
    <v-card-text class="pt-2 pb-2">
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs6 class="pa-1">
            <v-text-field
            v-model="lProjBillingDet.present_days"
            label="Present Days"
            hide-details
            type="number"
            @input="calculateBilledAmtBasedOnPresentdays()"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="pa-1">
            <v-text-field
            v-model="lProjBillingDet.wo"
            label="W/off"
            hide-details
            type="number"
            @input="calculateBilledAmtBasedOnPresentdays()"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="pa-1">
            <v-text-field
            v-model="lProjBillingDet.holidays"
            label="Govt. Holiday"
            hide-details
            type="number"
            @input="calculateBilledAmtBasedOnPresentdays()"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="pa-1">
            <v-text-field
            v-model="lProjBillingDet.tot_days_worked"
            label="Total Days Worked"
            hide-details
            disabled
            type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="pa-1">
            <v-text-field
            v-model="lProjBillingDet.chargeable_amt"
            label="Chargeable Amount"
            hide-details
            disabled
            type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 class="pa-1">
            <v-text-field
            v-model="lProjBillingDet.billed_amt"
            label="Billed Amount"
            hide-details
            disabled
            type="number"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn @click="showEditProjectBillingDet = false">close</v-btn>
      <v-btn class="accent" @click="saveUpdatedProjectBillingDetails(lProjBillingDet)">save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- 4. Add new service -->
<v-dialog v-model="showtoAddExistingBillingDet" persistent scrollable max-width="600px">
  <v-card>
    <v-card-title class="py-2 grey lighten-4">
      {{lProjBillingService.action}} New services
    </v-card-title>
    <v-card-text class="pt-2 pb-2">
      <v-flex xs12>
        <v-select
        v-model="lProjBillingService.category"
        :items="['Add from Existing Contract', 'Add new Services']"
        label="Services"
        hide-details
        ></v-select>
      </v-flex>
      <v-flex xs12 v-if="lProjBillingService.category === 'Add new Services'" class="px-2">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-layout row wrap>
              <v-flex xs6 class="pa-1">
                <v-text-field
                v-model="lAddToExistingProjBillingDet.billing_service_text"
                label="Service Name"
                hide-details
                :disabled="lProjBillingService.action === 'Update'"
                maxlength="250"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="pa-1">
                <v-text-field
                v-model="lAddToExistingProjBillingDet.chargeable_amt"
                label="Chargeable Amount"
                hide-details
                @input="calculateTotalGstAmt(lAddToExistingProjBillingDet)"
                type="Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="pa-1">
                <v-text-field
                v-model="lAddToExistingProjBillingDet.Mgmt_fee_per"
                label="Mgmt per"
                hide-details
                @input="calculateTotalGstAmt(lAddToExistingProjBillingDet)"
                type="Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="pa-1">
                <v-text-field
                v-model="lAddToExistingProjBillingDet.Mgmt_fee_amt"
                label="Mgmt Amount"
                hide-details
                disabled
                type="Number"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 class="px-2">
                <v-checkbox
                label="Is IGST" hide-details
                v-model="lAddToExistingProjBillingDet.is_igst"></v-checkbox>
              </v-flex>
              <v-flex xs4 class="px-2">
                <v-text-field
                v-model="lAddToExistingProjBillingDet.igst_per"
                label="IGST %"
                type="number"
                hide-details
                :disabled="lAddToExistingProjBillingDet.is_igst ? false : true"
                @input="calculateTotalGstAmt(lAddToExistingProjBillingDet)"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 class="px-2">
                <v-text-field
                v-model="lAddToExistingProjBillingDet.igst_amt"
                label="IGST Fee"
                type="number"
                hide-details
                disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="px-2">
                <v-layout row wrap>
                  <v-flex xs3 class="px-2">
                    <v-text-field
                    v-model="lAddToExistingProjBillingDet.cgst_per"
                    label="CGST %"
                    type="number"
                    hide-details
                    :disabled="lAddToExistingProjBillingDet.is_igst ? true : false"
                    @input="calculateTotalGstAmt(lAddToExistingProjBillingDet)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 class="px-2">
                    <v-text-field
                    v-model="lAddToExistingProjBillingDet.cgst_amt"
                    label="CGST Fee"
                    type="number"
                    hide-details
                    disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 class="px-2">
                    <v-text-field
                    v-model="lAddToExistingProjBillingDet.sgst_per"
                    label="SGST %"
                    type="number"
                    hide-details
                    :disabled="lAddToExistingProjBillingDet.is_igst ? true : false"
                    @input="calculateTotalGstAmt(lAddToExistingProjBillingDet)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3 class="px-2">
                    <v-text-field
                    v-model="lAddToExistingProjBillingDet.sgst_amt"
                    label="SGST Fee"
                    type="number"
                    hide-details
                    disabled
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6 class="pa-1">
                <v-text-field
                v-model="lAddToExistingProjBillingDet.billed_amt"
                label="Billed Amount"
                hide-details
                disabled
                type="Number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn @click="showtoAddExistingBillingDet = false">close</v-btn>
            <v-btn class="accent" @click="saveServiceProjectBillingDetails(lAddToExistingProjBillingDet, lProjBillingService.action)">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="lProjBillingService.category === 'Add from Existing Contract'" class="pa-0">
        <v-card flat class="pt-3">
          <v-card-text class="pa-0">
            <v-data-table
            v-model="selected"
            show-select
            :headers="projContractServiceHeadList"
            :items="projContractServiceDetList"
            hide-default-footer
            disable-sort
            disable-pagination
            dense
            item-key="staff_role"
            class="elevation-1"
            :mobile-break-point="0">
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showtoAddExistingBillingDet = false">close</v-btn>
          <v-btn class="accent" :disabled="beingSaved" @click="importToProjectBilling(selected)">Import to Bill # {{lBillNo}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-card-text>
</v-card>
</v-dialog>

<!-- 5. give the comments based on version status -->
<v-dialog v-model="showCommentDlg" scrollable persistent max-width="500px">
  <v-card>
    <v-card-title class="px-3 py-2 title grey lighten-4">
      {{lProjBillingStatus.status}} Remarks
      <v-spacer></v-spacer>
      <v-btn icon @click="showCommentDlg = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-flex xs12 v-if="lProjBillingStatus.status === 'Submitted'">
        <v-textarea hide-details outlined
        placeholder="Please Enter the Submit Remarks"
        maxlength="250"
        v-model="lProjBillingStatus.submit_remarks"></v-textarea>
      </v-flex>
      <v-flex xs12 v-if="lProjBillingStatus.status === 'Approved'">
        <v-textarea hide-details outlined
        placeholder="Please Enter the Approve Remarks"
        maxlength="250"
        v-model="lProjBillingStatus.approve_remarks"></v-textarea>
      </v-flex>
      <v-flex xs12 v-if="lProjBillingStatus.status === 'Draft'">
        <v-textarea hide-details outlined
        placeholder="Please Enter the Draft Remarks"
        maxlength="250"
        v-model="lProjBillingStatus.drafted_remarks"></v-textarea>
      </v-flex>
      <v-flex xs12 v-if="lProjBillingStatus.status === 'Rejected'">
        <v-textarea hide-details outlined
        placeholder="Please Enter the Rejected Remarks"
        maxlength="250"
        v-model="lProjBillingStatus.rejected_remarks"></v-textarea>
      </v-flex>
    </v-card-text>
    <v-card-actions class="px-3 pt-0">
      <v-spacer></v-spacer>
      <v-btn class="accent" @click="statusChangeTheProjectContract(lProjBillingStatus, lProjBillingStatus.status)">save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- 6. project billing view as PDF -->
<v-dialog scrollable v-model="showViewAsPdf" max-width="900px">
  <v-card>
    <v-card-title class="py-2 grey lighten-3">
      Project Billing
      <v-spacer></v-spacer>
      <v-btn icon small @click="showViewAsPdf = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12 class="py-2 px-2 mr-2">
        <v-layout row wrap>
          <v-flex xs8>
            <v-spacer></v-spacer>
          </v-flex>
          <v-flex xs4 class="text-right">
            <v-download-as
            :headers="BillingViewHeaders"
            :items="projBillingView"
            :title="lProjBilling.proj_name"
            :fontsize="8"
            :subtitle="'Billing Summary from ' + lProjBilling.billing_start_date + ' to ' + lProjBilling.billing_end_date + ' - Billing Cycle Days - ' + lProjBilling.billing_cycle"
            ></v-download-as>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="mt-2" id="pdf_report">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-flex xs12 style="margin-right: 5px;">
              <div style="border: 1px solid black; font-family: Arial, Helvetica, sans-serif; text-align: center; color:#000; padding-top: 2px; font-size: 22px;">{{lProjBilling.proj_name}}</div>
              <div style="border-left: 1px solid black; border-right: 1px solid black; font-family: Arial, Helvetica, sans-serif; text-align: center; color:#000; padding-top: 2px; font-size: 12px;">Billing Summary from {{lProjBilling.billing_start_date}} to {{lProjBilling.billing_end_date}} - Billing Cycle Days - {{lProjBilling.billing_cycle}}</div>
            </v-flex>
            <v-flex xs12 class="pa-0" style="margin-right: 5px; border: 1px solid black;">
              <v-data-table
              :headers="BillingViewHeaders"
              hide-default-header
              :items="projBillingView"
              disable-sort
              hide-default-footer
              dense
              disable-pagination>
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th style="background-color: #cee6f5;font-size: 12px; border-right: 1px solid black; border-bottom: 1px solid black; font-family: Arial, Helvetica, sans-serif; width: 210px; text-align: left;">{{headers[0].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; border-right: 1px solid black; border-bottom: 1px solid black; font-family: Arial, Helvetica, sans-serif; width: 60px; text-align: left;">{{headers[1].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; border-right: 1px solid black; border-bottom: 1px solid black; font-family: Arial, Helvetica, sans-serif; width: 60px; text-align: left;">{{headers[2].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; border-right: 1px solid black; border-bottom: 1px solid black; font-family: Arial, Helvetica, sans-serif; width: 65px; text-align: left;">{{headers[3].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; border-right: 1px solid black; border-bottom: 1px solid black; font-family: Arial, Helvetica, sans-serif; width: 60px; text-align: left;">{{headers[4].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; border-right: 1px solid black; border-bottom: 1px solid black; font-family: Arial, Helvetica, sans-serif; width: 60px; text-align: left;">{{headers[5].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; border-right: 1px solid black; border-bottom: 1px solid black; font-family: Arial, Helvetica, sans-serif; width: 115px; text-align: left;">{{headers[6].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; border-bottom: 1px solid black; font-family: Arial, Helvetica, sans-serif; width: 115px; text-align: left;">{{headers[7].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Service Sub Total' ? 'background-color: #93f0cf; color:#09391f;' : props.item.staff_role === 'Grand Total before GST' ? 'background-color: #44cb82; color: #fff; border-bottom: 1px solid black;' : props.item.staff_role === 'Grand Total with GST' ? 'background-color: #4570d6; color: #fff; font-weight: bold; border-bottom: 1px solid black;' : ' border-bottom: 1px solid black; color:#000;'">
                  <td :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Grand Total before GST' || props.item.staff_role === 'Manpower Total'  || props.item.staff_role === 'Service Total' ? 'font-size: 12px; border-right: 1px solid black; font-weight: bold; vertical-align: top; font-family: Arial, Helvetica, sans-serif;' : 'font-size: 12px; border-right: 1px solid black; vertical-align: top; font-family: Arial, Helvetica, sans-serif;'">{{ props.item.staff_role }}</td>
                  <td :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Grand Total before GST' || props.item.staff_role === 'Manpower Total'  || props.item.staff_role === 'Service Total' ? 'font-size: 12px; border-right: 1px solid black; font-weight: bold; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;' : 'font-size: 12px; border-right: 1px solid black; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;'">{{ props.item.head_count }}</td>
                  <td :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Grand Total before GST' || props.item.staff_role === 'Manpower Total'  || props.item.staff_role === 'Service Total' ? 'font-size: 12px; border-right: 1px solid black; font-weight: bold; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;' : 'font-size: 12px; border-right: 1px solid black; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;'">{{ props.item.present_days }}</td>
                  <td :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Grand Total before GST' || props.item.staff_role === 'Manpower Total'  || props.item.staff_role === 'Service Total' ? 'font-size: 12px; border-right: 1px solid black; font-weight: bold; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;' : 'font-size: 12px; border-right: 1px solid black; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;'">{{ props.item.wo }}</td>
                  <td :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Grand Total before GST' || props.item.staff_role === 'Manpower Total'  || props.item.staff_role === 'Service Total' ? 'font-size: 12px; border-right: 1px solid black; font-weight: bold; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;' : 'font-size: 12px; border-right: 1px solid black; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;'">{{ props.item.holidays }}</td>
                  <td :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Grand Total before GST' || props.item.staff_role === 'Manpower Total'  || props.item.staff_role === 'Service Total' ? 'font-size: 12px; border-right: 1px solid black; font-weight: bold; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;' : 'font-size: 12px; border-right: 1px solid black; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: center;'">{{ props.item.tot_days_worked }}</td>
                  <td :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Grand Total before GST' || props.item.staff_role === 'Manpower Total'  || props.item.staff_role === 'Service Total' ? 'font-size: 12px; border-right: 1px solid black; font-weight: bold; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: right;' : 'font-size: 12px; border-right: 1px solid black; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: right;'">{{ props.item.chargeable_amt ? handy.formatCur(props.item.chargeable_amt) : null }}</td>
                  <td :style="props.item.staff_role === 'Sub total' || props.item.staff_role === 'Grand Total before GST' || props.item.staff_role === 'Manpower Total'  || props.item.staff_role === 'Service Total' ? 'font-size: 12px; font-weight: bold; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: right;' : 'font-size: 12px; vertical-align: top; font-family: Arial, Helvetica, sans-serif; text-align: right;'">{{ handy.formatCur(props.item.billed_amt) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-card-text>
</v-card>
</v-dialog>

<!-- 7. show filter category in bottom sheet -->
<v-bottom-sheet inset class="caption" v-model="showFilter" max-width="500px">
  <v-card>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
            v-model="filterList.proj_contract_base_id"
            :items="projContractList"
            item-text="proj_name"
            item-value="proj_contract_base_id"
            label="Project"
            hide-details
            multiple
            small chips
            clearable
            deletable-chips
            dense
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-dialog ref="dlgBillingMon"
            persistent v-model="dlgBillingMon"
            max-width="290px"
            :return-value.sync="filterList.billing_monthAndYear"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="Billing Month &amp; Year"
              :rules="[rules.required]"
              v-model="filterList.billing_monthAndYear" append-icon="mdi-calendar-today"
              readonly clearable hide-details
              v-on="on" :disabled="lAction === 'update'"
              ></v-text-field>
            </template>
            <v-date-picker type="month" :disabled="lAction === 'update'"
            v-model="filterList.billing_monthAndYear" scrollable
            first-day-of-week="1"
            >
            <v-spacer></v-spacer>
            <v-btn text @click="dlgBillingMon = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgBillingMon.save(filterList.billing_monthAndYear)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</v-card-text>
<v-card-actions class="px-5 mx-4 pb-3">
  <v-btn @click.stop="showFilter = false">Close</v-btn>
  <v-spacer></v-spacer>
  <v-btn @click="clearFilter">Clear all</v-btn>
  <v-btn class="ml-2" color="accent" @click="applyFilter">Apply</v-btn>
</v-card-actions>
</v-card>
</v-bottom-sheet>

<!-- 8. project contract view based on base id -->
<v-dialog scrollable v-model="showContractViewAsPdf" max-width="900px">
  <v-card>
    <v-card-title class="py-2 grey lighten-3">
      Project Contract
      <v-spacer></v-spacer>
      <v-btn icon small @click="showContractViewAsPdf = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-card flat>
          <v-card-text class="pa-0">
            <!-- 1st and 2nd view-->
            <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-0' || attTab === 'tab-1'">
              <v-layout row wrap>
                <v-flex xs12 v-if="projContractView[0] && projContractView[0].length > 0 && projContractView[0][0].proj_contract_sub_category">
                  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;font-weight: semi-bold;">{{projContractView[0][0].heading}}</div>
                    <v-data-table
                    :headers="techHeaders"
                    hide-default-header
                    :items="projContractView[0]"
                    disable-sort
                    hide-default-footer
                    dense
                    disable-pagination>
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                        <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                  <v-flex xs12>
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="background-color: #fff; font-family: Arial, Helvetica, sans-serif; color: #000;">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Sub Total</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].total_amount) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                  <v-flex xs12 v-if="attTab === 'tab-0'">
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="(mgmt, i) in projContractView[1]" :key="i">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #93f0cf; font-family: Arial, Helvetica, sans-serif; color: #09391f;">
                          <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].before_gst) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="gst in projContractView[2]" :key="gst.gst_amt">
                          <td style="font-size: 12px; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(gst.tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #44cb82; font-family: Arial, Helvetica, sans-serif; color: #fff;">
                          <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[0][0].heading.substring(10, projContractView[0][0].heading.length)}} Grand Total with GST</td>
                          <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[0].gst_tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-flex>
              </v-flex>
              <div style="page-break-after:always; clear:both"></div>
              <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[3] && projContractView[3].length > 0 && projContractView[3][0].staff_role">
                <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                  <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">{{projContractView[3][0].heading}}</div>
                  <v-flex xs12>
                    <v-flex xs12 v-for="(cat, i) in category" :key="i" v-if="projContractView[3].filter(rec => rec.role_cat === cat).length > 0">
                      <div style="padding: 4px 0px; font-size: 12px; font-family: Arial, Helvetica, sans-serif; background-color: #71c1f5; color: #000; text-align: center;">
                        {{handy.startWithUpper(cat.toLowerCase())}}
                      </div>
                      <v-data-table
                      :headers="manpowerHeaders"
                      hide-default-header
                      :items="projContractView[3].filter(rec => rec.role_cat === cat)"
                      hide-default-footer
                      disable-sort
                      dense
                      disable-pagination
                      >
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12>
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="color: #000;">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].total_amount) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                  <v-flex xs12 v-if="attTab === 'tab-0'">
                    <table width="100%" cellpadding="0" cellspacing="0">
                      <tbody>
                        <tr style="color: #000;" v-for="mgmt in projContractView[4]" :key="mgmt.Mgmt_fee_per">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.Mgmt_fee_per}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #93f0cf; color:#09391f;">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].before_gst) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="color: #000;" v-for="gst in projContractView[5]" :key="gst.gst_amt">
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                          <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(gst.tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                        <tr style="background-color: #44cb82; color: #fff;">
                          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[3][0].heading.substring(8, projContractView[3][0].heading.length)}} Grand Total with GST</td>
                          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                            {{ handy.formatCur(projContractView[3].gst_tax_amt) }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-flex>
            <div style="page-break-after:always; clear:both"></div>
            <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[6] && projContractView[6].length && projContractView[6][0].staff_role">
              <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[6][0].heading}}</div>
                <v-flex xs12 v-if="projContractView[6].filter(rec => rec.role_cat === 'SAFTY/SECURITY').length > 0">
                  <v-divider class="black"></v-divider>
                  <v-data-table
                  :headers="manpowerHeaders"
                  hide-default-header
                  :items="projContractView[6]"
                  disable-sort
                  hide-default-footer
                  dense
                  disable-pagination
                  >
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                        <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                      </tr>
                    </thead>
                  </template>
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                      <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <v-flex xs12>
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tbody>
                      <tr style="color: #000;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].total_amount) }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
                <v-flex xs12 v-if="attTab === 'tab-0'">
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tbody>
                      <tr style="color: #000;" v-for="mgmt in projContractView[7]" :key="mgmt.Mgmt_fee_per">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; width: 100px;">Management fees ({{mgmt.Mgmt_fee_per}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="background-color: #93f0cf; color:#09391f;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].before_gst) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="color: #000;" v-for="gst in projContractView[8]" :key="gst.gst_amt">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(gst.tax_amt) }}
                        </td>
                        <td></td>
                      </tr>
                      <tr style="background-color: #44cb82; color: #fff;">
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[6][0].heading.substring(8, projContractView[6][0].heading.length)}} Grand Total with GST</td>
                        <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                          {{ handy.formatCur(projContractView[6].gst_tax_amt) }}
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-flex>
          <div style="page-break-after:always; clear:both"></div>
          <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[9] && projContractView[9].length && projContractView[9][0].proj_contract_sub_category">
            <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
              <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[9][0].heading}}</div>
              <v-data-table
              :headers="techHeaders"
              hide-default-header
              disable-sort
              :items="projContractView[9]"
              hide-default-footer
              dense
              disable-pagination
              >
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                  </tr>
                </thead>
              </template>
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-flex xs12>
              <table width="100%" cellpadding="0" cellspacing="0">
                <tbody>
                  <tr style="color: #000;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].total_amount) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
            <v-flex xs12 v-if="attTab === 'tab-0'">
              <table width="100%" cellpadding="0" cellspacing="0">
                <tbody>
                  <tr style="color: #000;" v-for="mgmt in projContractView[10]" :key="mgmt.Mgmt_fee_per">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="background-color: #93f0cf; color:#09391f;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].before_gst) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="color: #000;" v-for="gst in projContractView[11]" :key="gst.gst_amt">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(gst.tax_amt) }}
                    </td>
                    <td></td>
                  </tr>
                  <tr style="background-color: #44cb82; color: #fff;">
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[9][0].heading.substring(21, projContractView[9][0].heading.length)}} Grand Total with GST</td>
                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                      {{ handy.formatCur(projContractView[9].gst_tax_amt) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-flex>
        </v-flex>
        <div style="page-break-after:always; clear:both"></div>
        <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[12] && projContractView[12].length && projContractView[12][0].proj_contract_sub_category">
          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
            <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[12][0].heading}}</div>
            <v-data-table
            :headers="techHeaders"
            hide-default-header
            disable-sort
            :items="projContractView[12]"
            hide-default-footer
            dense
            disable-pagination
            >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                </tr>
              </thead>
            </template>
            <template slot="item" slot-scope="props">
              <tr>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-flex xs12>
            <table width="100%" cellpadding="0" cellspacing="0">
              <tbody>
                <tr style="color: #000;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].total_amount) }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
          <v-flex xs12 v-if="attTab === 'tab-0'">
            <table width="100%" cellpadding="0" cellspacing="0">
              <tbody>
                <tr style="color: #000;" v-for="mgmt in projContractView[13]" :key="mgmt.Mgmt_fee_per">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="background-color: #93f0cf; color:#09391f;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].before_gst) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="color: #000;" v-for="gst in projContractView[14]" :key="gst.gst_amt">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(gst.tax_amt) }}
                  </td>
                  <td></td>
                </tr>
                <tr style="background-color: #44cb82; color: #fff;">
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[12][0].heading.substring(13, projContractView[12][0].heading.length)}} Grand Total with GST</td>
                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                    {{ handy.formatCur(projContractView[12].gst_tax_amt) }}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </v-flex>
        </v-flex>
      </v-flex>
      <div style="page-break-after:always; clear:both"></div>
      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[15] && projContractView[15].length && projContractView[15][0].proj_contract_sub_category">
        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[15][0].heading}}</div>
          <v-data-table
          :headers="techHeaders"
          hide-default-header
          disable-sort
          :items="projContractView[15]"
          hide-default-footer
          dense
          disable-pagination
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
              <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-flex xs12>
          <table width="100%" cellpadding="0" cellspacing="0">
            <tbody>
              <tr style="color: #000;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].total_amount) }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </v-flex>
        <v-flex xs12 v-if="attTab === 'tab-0'">
          <table width="100%" cellpadding="0" cellspacing="0">
            <tbody>
              <tr style="color: #000;" v-for="mgmt in projContractView[16]" :key="mgmt.Mgmt_fee_per">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                </td>
                <td></td>
              </tr>
              <tr style="background-color: #93f0cf; color:#09391f;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].before_gst) }}
                </td>
                <td></td>
              </tr>
              <tr style="color: #000;" v-for="gst in projContractView[17]" :key="gst.gst_amt">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(gst.tax_amt) }}
                </td>
                <td></td>
              </tr>
              <tr style="background-color: #44cb82; color: #fff;">
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[15][0].heading.substring(13, projContractView[15][0].heading.length)}} Grand Total with GST</td>
                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                  {{ handy.formatCur(projContractView[15].gst_tax_amt) }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </v-flex>
      </v-flex>
    </v-flex>
    <div style="page-break-after:always; clear:both"></div>
    <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[18] && projContractView[18].length && projContractView[18][0].proj_contract_sub_category">
      <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
        <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[18][0].heading}}</div>
        <v-data-table
        :headers="techHeaders"
        hide-default-header
        disable-sort
        :items="projContractView[18]"
        hide-default-footer
        dense
        disable-pagination
        >
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <tr>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
            <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-flex xs12>
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].total_amount) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
      <v-flex xs12 v-if="attTab === 'tab-0'">
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;" v-for="mgmt in projContractView[19]" :key="mgmt.Mgmt_fee_per">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #93f0cf; color:#09391f;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].before_gst) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;" v-for="gst in projContractView[20]" :key="gst.gst_amt">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(gst.tax_amt) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #44cb82; color: #fff;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[18][0].heading.substring(5, projContractView[18][0].heading.length)}} Grand Total with GST</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur(projContractView[18].gst_tax_amt) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-flex>
  </v-flex>
  <div style="page-break-after:always; clear:both"></div>
  <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[21] && projContractView[21].length && projContractView[21][0].proj_contract_sub_category">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[21][0].heading}}</div>
      <v-data-table
      :headers="techHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[21]"
      hide-default-footer
      dense
      disable-pagination
      >
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
          <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-flex xs12>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].total_amount) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
    <v-flex xs12 v-if="attTab === 'tab-0'">
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;" v-for="mgmt in projContractView[22]" :key="mgmt.Mgmt_fee_per">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;" v-for="gst in projContractView[23]" :key="gst.gst_amt">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(gst.tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[21][0].heading.substring(20, projContractView[21][0].heading.length)}} Grand Total with GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[21].gst_tax_amt) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
</v-flex>
<div style="page-break-after:always; clear:both"></div>
<v-flex xs12 style="padding-top: 8px;" v-if="projContractView[24] && projContractView[24].length && projContractView[24][0].proj_contract_sub_category">
  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[24][0].heading}}</div>
    <v-data-table
    :headers="techHeaders"
    hide-default-header
    disable-sort
    :items="projContractView[24]"
    hide-default-footer
    dense
    disable-pagination
    >
    <template v-slot:header="{ props: { headers } }">
      <thead>
        <tr>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
          <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
        </tr>
      </thead>
    </template>
    <template slot="item" slot-scope="props">
      <tr>
        <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
        <td style="font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
        <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
      </tr>
    </template>
  </v-data-table>
  <v-flex xs12>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].total_amount) }}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
  <v-flex xs12 v-if="attTab === 'tab-0'">
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;" v-for="mgmt in projContractView[25]" :key="mgmt.Mgmt_fee_per">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #93f0cf; color:#09391f;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].before_gst) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;" v-for="gst in projContractView[26]" :key="gst.gst_amt">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(gst.tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[24][0].heading.substring(9, projContractView[24][0].heading.length)}} Grand Total with GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[24].gst_tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td colspan="3"></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
</v-flex>
</v-flex>
<!-- SUMMARY -->
<div style="page-break-after:always; clear:both"></div>
<v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
  <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
    <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
    <table width="100%" cellpadding="0" cellspacing="0">
      <tbody>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].sub_total) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #93f0cf; color:#09391f;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].before_gst) }}
          </td>
          <td></td>
        </tr>
        <tr style="color: #000;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].tax_amt) }}
          </td>
          <td></td>
        </tr>
        <tr style="background-color: #44cb82; color: #fff;">
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
          <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
            {{ handy.formatCur(projContractView[27][0].after_gst) }}
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </v-flex>
</v-flex>
<v-flex xs12 v-else>
  <div>
    No Data Available
  </div>
</v-flex>
</v-layout>
</v-flex>

<!-- 3rd view -->
<v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-2'">
  <v-layout row wrap>
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
      <v-data-table
      :headers="manpowerHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[0].concat(projContractView[3]).concat(projContractView[6]).concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
      hide-default-footer
      dense
      disable-pagination>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr v-if="props.item.staff_role || props.item.proj_contract_sub_category">
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role ? props.item.staff_role : props.item.proj_contract_sub_category }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count ? props.item.head_count : 1 }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc ? props.item.amt_per_hc : props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt ? props.item.total_hc_amt : props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
  <div style="page-break-after:always; clear:both"></div>
  <v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].sub_total) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[27][0].after_gst) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
  <v-flex xs12 v-else>
    <div>
      No Data Available
    </div>
  </v-flex>
</v-layout>
</v-flex>

<!-- 4th view -->
<v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-3'">
  <v-layout row wrap>
    <v-flex xs12 v-if="(projContractView[3] && projContractView[3].length > 0  && projContractView[3][0].staff_role) || (projContractView[6] && projContractView[6].length > 0 && projContractView[6][0].staff_role)">
      <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
        <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">MANPOWER</div>
        <v-data-table
        :headers="manpowerHeaders"
        hide-default-header
        disable-sort
        :items="projContractView[3].concat(projContractView[6])"
        hide-default-footer
        dense
        disable-pagination>
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
              <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
            </tr>
          </thead>
        </template>
        <template slot="item" slot-scope="props">
          <tr>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
            <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-flex xs12>
        <table width="100%" cellpadding="0" cellspacing="0">
          <tbody>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].total_amount ? projContractView[3].total_amount : 0) + (projContractView[6].total_amount ? projContractView[6].total_amount : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].mgmt ? projContractView[3].mgmt : 0) + (projContractView[6].mgmt ? projContractView[6].mgmt : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #93f0cf; color:#09391f;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].before_gst ? projContractView[3].before_gst : 0) + (projContractView[6].before_gst ? projContractView[6].before_gst : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="color: #000;">
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
              <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].tax_amt ? projContractView[3].tax_amt : 0) + (projContractView[6].tax_amt ? projContractView[6].tax_amt : 0)) }}
              </td>
              <td></td>
            </tr>
            <tr style="background-color: #44cb82; color: #fff;">
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
              <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                {{ handy.formatCur((projContractView[3].gst_tax_amt ? projContractView[3].gst_tax_amt : 0) + (projContractView[6].gst_tax_amt ? projContractView[6].gst_tax_amt : 0)) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-flex>
  </v-flex>
  <v-flex xs12 style="padding-top: 6px;" v-if="projContractView[28] && projContractView[28][0].total_amount">
    <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
      <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">SERVICE</div>
      <v-data-table
      :headers="techHeaders"
      hide-default-header
      disable-sort
      :items="projContractView[0].concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
      hide-default-footer
      dense
      disable-pagination>
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
            <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
          <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-flex xs12>
      <table width="100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].total_amount) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].mgmt_fee) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #93f0cf; color:#09391f;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].before_gst) }}
            </td>
            <td></td>
          </tr>
          <tr style="color: #000;">
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
            <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28].tax_amt) }}
            </td>
            <td></td>
          </tr>
          <tr style="background-color: #44cb82; color: #fff;">
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
            <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
              {{ handy.formatCur(projContractView[28][0].total_amt) }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-flex>
</v-flex>
</v-layout>
</v-flex>
</v-card-text>
</v-card>
</v-flex>
</v-card-text>
<v-card-actions class="pt-0">
  <v-flex xs12>
    <v-tabs v-model="attTab" show-arrows>
      <v-tab v-for="(attitem, n) in viewTabItems" :key="n" :href="`#tab-${n}`" @click="changeView(attitem)">
        {{attitem}}
      </v-tab>
    </v-tabs>
  </v-flex>
</v-card-actions>
</v-card>
</v-dialog>

<!-- 10. Timeline -->
<v-dialog scrollable v-model="showTimelineInfo" max-width="500px">
  <v-flex xs12>
    <v-card flat>
      <v-card-title class="py-1 title grey lighten-4">
        <div>Timeline</div>
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="showTimelineInfo = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-timeline
        dense class="mt-2 pt-2"
        reverse
        >
        <v-timeline-item
        small right fill-dot
        icon="mdi-star" v-if="lProjBilling.rejected_date"
        >
        <v-card class="elevation-2">
          <v-card-title class="subtitle-1 py-1 grey lighten-3">Rejected</v-card-title>
          <v-card-text class="pb-2 pt-1">
            Rejected by {{lProjBilling.rejected_by_name}} on {{lProjBilling.rejected_date ? handy.formatDate(lProjBilling.rejected_date) : ''}} with remarks {{lProjBilling.rejected_remark ? lProjBilling.rejected_remark : '-'}}
          </v-card-text>
        </v-card>
      </v-timeline-item>
      <v-timeline-item
      small right fill-dot
      icon="mdi-star" v-if="lProjBilling.approved_date"
      >
      <v-card class="elevation-2">
        <v-card-title class="subtitle-1 py-1 grey lighten-3">Approved</v-card-title>
        <v-card-text class="pb-2 pt-1">
          Approved by {{lProjBilling.approved_by_name}} on {{lProjBilling.approved_date ? handy.formatDate(lProjBilling.approved_date) : ''}} with remarks {{lProjBilling.approved_remark ? lProjBilling.approved_remark : '-'}}
        </v-card-text>
      </v-card>
    </v-timeline-item>
    <v-timeline-item
    small right fill-dot
    icon="mdi-star" v-if="lProjBilling.submitted_date"
    >
    <v-card class="elevation-2">
      <v-card-title class="subtitle-1 py-1 grey lighten-3">Submitted</v-card-title>
      <v-card-text class="pb-2 pt-1">
        Submiited by {{lProjBilling.submitted_by_name}} on {{lProjBilling.submitted_date ? handy.formatDate(lProjBilling.submitted_date) : ''}} with remarks {{lProjBilling.submitted_remark ? lProjBilling.submitted_remark : '-'}}
      </v-card-text>
    </v-card>
  </v-timeline-item>
  <v-timeline-item
  small right fill-dot
  icon="mdi-star" v-if="lProjBilling.updated_date"
  >
  <v-card class="elevation-2">
    <v-card-title class="subtitle-1 py-1 grey lighten-3">Created</v-card-title>
    <v-card-text class="pb-2 pt-1">
      Created by {{lProjBilling.updated_by}} on {{lProjBilling.updated_date ? handy.formatDate(lProjBilling.updated_date) : ''}}
    </v-card-text>
  </v-card>
</v-timeline-item>
<v-timeline-item
small right fill-dot
icon="mdi-star"
>
<v-card class="elevation-2">
  <v-card-title class="subtitle-1 py-1 grey lighten-3">Created</v-card-title>
  <v-card-text class="pb-2 pt-1">
    Created by {{lProjBilling.created_by}} on {{lProjBilling.created_date ? handy.formatDate(lProjBilling.created_date) : ''}}
  </v-card-text>
</v-card>
</v-timeline-item>
</v-timeline>
</v-card-text>
</v-card>
</v-flex>
</v-dialog>

<!-- Plus button -->
<v-btn
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed color="accent" v-if="lAction === 'view' && (config.IS_EDITED_BY_USER)"
@click.native="prepareCreate"><v-icon>mdi-plus</v-icon></v-btn>

<!-- filter btn -->
<v-btn small v-if="lAction === 'view'"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:85px;':'bottom:15px; right:85px;')"
dark fab fixed color="accent black--text" @click.native="prepareFilter()">
<v-icon class="pa-2">mdi-filter-variant</v-icon>
</v-btn>

<!-- 11. comparison of last 3 months data -->
<v-dialog v-model="showComparisonData" max-width="1200px" scrollable>
  <v-flex xs12>
    <v-card>
      <v-card-title class="primary--text grey lighten-3 py-2">
        {{projectBill.proj_name}} - {{projectBill.current_month.substring(0,8)}}
        <v-spacer></v-spacer>
        <v-btn icon small @click="showComparisonData = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pt-3">
        <v-flex xs12>
          <v-data-table
          hide-default-header
          :headers="comparisonDataList"
          :items="comparisonDataList"
          dense
          hide-default-footer
          disable-pagination
          class="elevation-2"
          :mobile-breakpoint="0"
          >
          <template v-slot:header="{ props: { headers } }">
            <thead>
              <tr>
                <td colspan="6" style="background-color: #c23dad; color: #fff; font-size: 12px; font-weight: bold;" class="text-center">Month wise billing value</td>
                <td colspan="2" class="text-center" style="border-left: 1px solid black; background-color: #c23dad; color: #fff; font-size: 12px; font-weight: bold;">Comparison</td>
              </tr>
              <tr>
                <th style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].sr_no}}</th>
                <th style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].staff_role}}</th>
                <th class="text-right pr-2" style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].previous_month_billed_amt}}</th>
                <th class="text-right" :style="projectBill.current_month === headers[0].current_month_billed_amt ? 'background-color: #B8BB26; color: #fff; font-size: 12px; padding-right: 4px; font-weight: 800;' : 'background-color: #4570d6; color: #fff; font-size: 12px; padding-right: 0px;'">{{headers[0].current_month_billed_amt}}</th>
                <th class="text-right pr-2" style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].next_month_billed_amt}}</th>
                <td style="width: 5px; background-color: #4570d6;"></td>
                <th class="text-right px-0" style="background-color: #4570d6; color: #fff; font-size: 12px; border-left: 1px solid black;">{{headers[0].first_comparison}}</th>
                <th class="text-right" style="background-color: #4570d6; color: #fff; font-size: 12px;">{{headers[0].sec_comparison}}</th>
              </tr>
            </thead>
          </template>
          <template slot="item" slot-scope="props">
            <tr v-if="props.index > 0" :style="props.item.staff_role === 'Total' ? 'background-color: #44cb82; color: #fff; font-weight: bold; font-size: 12px;' : 'font-size: 10px;'">
              <td style="font-size: 12px;" v-if="props.item.staff_role !== 'Total'">{{ props.index }}</td>
              <td v-else></td>
              <td style="font-size: 12px;">{{ props.item.staff_role }}</td>
              <td style="font-size: 12px;" :class="'text-right pr-2'">{{ handy.formatCur(parseInt(props.item.previous_month_billed_amt)) }}</td>
              <td style="font-size: 12px;" :class="'text-right pr-2'" :style="props.item.staff_role === 'Total' ? '' : 'background-color: #E9FFB8; font-weight: bold;'">{{ handy.formatCur(parseInt(props.item.current_month_billed_amt)) }}</td>
              <td style="font-size: 12px;" :class="'text-right pr-2'">{{ handy.formatCur(parseInt(props.item.next_month_billed_amt)) }}</td>
              <td style="width: 5px;"></td>
              <td :class="props.item.first_comparison < 0 ? 'text-right red--text pl-0' : 'text-right pl-0'" style="border-left: 1px solid black; font-size: 12px;">{{ handy.formatCur(parseInt(props.item.first_comparison)) }}</td>
              <td style="font-size: 12px;" :class="props.item.sec_comparison < 0 ? 'text-right red--text' : 'text-right'">{{ handy.formatCur(parseInt(props.item.sec_comparison)) }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 class="pt-2">
        <table width="100%" cellpadding="0" cellspacing="0">
          <tr>
            <td style="width: 75px;"></td>
            <td class="subheading">
              <v-chip small style="background-color:#4EA9D0; font-size: 12px; color:#fff;">
                <span v-if="projectBill.prev_comp === 'Infinity'">{{projectBill.prev_month}} month bill is not raised</span>
                <span v-else>{{projectBill.current_month}} month invoice value is {{(projectBill.current_month_billed_amt - projectBill.previous_month_billed_amt) > 0 ? 'increased' : 'decreased'}} Rs {{projectBill.prev_comp}} % by comparing {{projectBill.prev_month}}</span>
              </v-chip>
            </td>
            <td style="width: 75px;"></td>
            <td class="subheading">
              <v-chip small style="background-color:#4EA9D0; font-size: 12px; color:#fff;">
                <span v-if="projectBill.next_comp === 'Infinity'">{{projectBill.next_month}} month bill is not raised</span>
                <span v-else>{{projectBill.current_month}} month invoice value is {{(projectBill.current_month_billed_amt - projectBill.next_month_billed_amt) > 0 ? 'increased' : 'decreased'}} Rs {{projectBill.next_comp}} % by comparing {{projectBill.next_month}}</span>
              </v-chip>
            </td>
            <td style="width: 75px;"></td>
          </tr>
        </table>
      </v-flex>
    </v-card-text>
  </v-card>
</v-flex>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-col>
</v-row>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'
var html2pdf = require('html2pdf.js')

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      lAction: 'view',
      handy: handy,
      config: config,
      rules: handy.rules,
      isClosedProject: false,
      beingSaved: false,
      // Frontend
      selTab: 0,
      projBillHead: [
        { text: 'S. No', value: '' },
        { text: 'Bill Month & Year', value: 'billing_month_year' },
        { text: 'Bill start date', value: 'billing_start_date' },
        { text: 'Bill end date', value: 'billing_end_date' },
        { text: 'Total Approved Billed Amt', value: 'approved_billed_amt' }
      ],
      projBillingList: [],
      projTitle: [],
      showTimelineInfo: false,
      // edit/create det form
      projBillingDetList: [],
      projContractList: [],
      dlgBillingMon: false,
      dlgBillingStartDate: false,
      dlgBillingEndDate: false,
      fromDate: null,
      toDate: null,
      lStatus: null,
      lBillNo: null,
      detHeaders: [
        { text: 'Sr no.', value: '', width: '50px', class: 'pr-0 primary lighten-1 white--text' },
        { text: 'Role', value: 'staff_role', width: '140px', class: 'primary lighten-1 white--text' },
        { text: 'HC', value: 'head_count', width: '50px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Billing Cycle', value: 'billing_cycle', width: '100px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Present days', value: 'present_days', width: '110px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'W/off', value: 'wo', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'NFH', value: 'holidays', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Total Days', value: 'tot_days_worked', width: '95px', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Charge/HC', value: 'chargeable_amt', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Billed Amt', value: 'billed_amt', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Mgmt Amt', value: 'Mgmt_fee_amt', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'GST Amt', value: 'gst_amt', width: '100px', class: 'primary lighten-1 white--text', align: 'right', sortable: false }
      ],
      billDetHistory: [
        { text: 'Bill No.', value: 'bill_no', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Bill Value', value: 'tot_billed_amt', class: 'pl-0 pr-1 primary lighten-1 white--text', sortable: false }
      ],
      billNoList: [],
      projContractDetList: [],
      showListOfProjContractDet: false,
      lProjBillingDet: [],
      showEditProjectBillingDet: false,
      // select from given list
      projContractHeadList: [
        { text: 'Role', value: 'staff_role', sortable: false },
        { text: 'Head Count', value: 'head_count', sortable: false },
        { text: 'Amount per HC', value: 'amt_per_hc', align: 'right', sortable: false }
      ],
      projContractServiceHeadList: [
        { text: 'Service', value: 'staff_role', sortable: false },
        { text: 'Service Amount', value: 'amt_per_hc', align: 'right', sortable: false }
      ],
      selected: [],
      totalBillingAmt: {
        tot_chargeable_amt: 0,
        tot_billed_amt: 0,
        total_man_cost: 0,
        total_ser_cost: 0
      },
      lProjBilling: {},
      // add new services
      contractServiceList: [],
      lProjBillingService: [],
      showtoAddExistingBillingDet: false,
      lAddToExistingProjBillingDet: [],
      projContractServiceDetList: [],
      // status dialog
      lProjBillingStatus: [],
      showCommentDlg: false,
      // billing view
      projBillingView: [],
      showViewAsPdf: false,
      BillingViewHeaders: [
        { text: 'Role', value: 'staff_role', class: 'primary lighten-1 white--text' },
        { text: 'HC', value: 'head_count', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Present days', value: 'present_days', align: 'center', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'W/off', value: 'wo', align: 'center', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'NFH', value: 'holidays', align: 'center', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Total Days', value: 'tot_days_worked', align: 'center', class: 'primary lighten-1 white--text', sortable: false },
        { text: 'Charge/HC', value: 'chargeable_amt', class: 'primary lighten-1 white--text', align: 'right', sortable: false },
        { text: 'Billed Amt', value: 'billed_amt', class: 'primary lighten-1 white--text', align: 'right', sortable: false }
      ],
      showContractViewAsPdf: false,
      projContractView: [],
      viewTabItems: ['Proposal breakup', 'end-to-end proposal', 'compressed view', 'M&S view'],
      attTab: 'tab-0',
      techHeaders: [
        { text: 'Category' , value: 'proj_contract_sub_category' },
        { text: 'Total' , value: 'amount', sortable: false },
        { text: 'Comments' , value: 'comments', sortable: false }
      ],
      manpowerHeaders: [
        { text: 'Category' , value: 'staff_role' },
        { text: 'No of Person' , value: 'head_count' },
        { text: 'Rate/Person' , value: 'amt_per_hc' },
        { text: 'Total' , value: 'total_hc_amt' },
        { text: 'Comments' , value: 'comments' }
      ],
      category: ['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'OTHERS'],
      comparisonDataList: [],
      showComparisonData: false,
      projectBill: {
        proj_name: '',
        prev_comp: 0,
        prev_month: '',
        next_month: '',
        next_comp: 0,
        current_month: '',
        current_month_billed_amt: 0,
        previous_month_billed_amt: 0,
        next_month_billed_amt: 0
      },
      // filter
      filterList: [],
      showFilter: false
    }
  },
  created () {
    this.lProjBilling = {}
    this.loadProjectBilling()
  },
  mounted () {
    this.filterList = this.getEmptyFilter()
  },
  methods: {
    searchProjectTitle (curRec) {
      if (curRec && curRec.length > 1) {
        var tmpVar = this.projTitle.filter(rec => rec.toLowerCase().includes(curRec.toLowerCase()))
        if (tmpVar.length > 0) {
          this.projTitle = []
          this.projTitle = tmpVar
        } else {
          this.projTitle = []
        }
      } else {
        this.loadProjectBilling()
      }
    },
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadProjectBilling () {
      var curDate = new Date()
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          is_closed_project: this.isClosedProject,
          from_dt: handy.formatDBDate(new Date(curDate.setMonth(curDate.getMonth() - 12))),
          filter: this.filterList
        }
      }
      this.axios.get(config.API_URL + '/getProjectBilling/', qry)
      .then(response => {
        if (response.data.length > 0 && response.data[0].proj_billing_base_id) {
          this.projBillingList = response.data
          this.projTitle = handy.unique(this.projBillingList.map(rec => rec.proj_name)).sort()
        } else {
          this.projBillingList = []
          this.projTitle = []
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreate () {
      this.lProjBillingBase = {
        proj_billing_base_pair: { proj_name: null, proj_contract_base_id: null },
        proj_id: null,
        billing_monthAndYear: null,
        billing_start_date: null,
        billing_end_date: null,
        created_by: config.EMP_ID,
        vendor_id: config.VENDOR_ID,
        action: 'create'
      }
      this.lProjBilling = {}
      this.projBillingDetList = []
      this.lStatus = 'Draft'
      this.loadProjectFromProjectContractList()
      this.lAction = 'create'
    },
    loadProjectFromProjectContractList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.projContractList = []
      this.axios.get(config.API_URL + '/getProjectFromProjectContractListBasedOnVendorId/', qry)
      .then(response => {
        this.projContractList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    basedOnSelectedMonthShowStartingAndEndingDate (curMonthAndYear) {
      this.lProjBillingBase.billing_year = this.lProjBillingBase.billing_monthAndYear.split('-')[0]
      this.lProjBillingBase.billing_month = this.lProjBillingBase.billing_monthAndYear.split('-')[1]
      var curDate = new Date(curMonthAndYear)
      curDate.setDate(1)
      this.fromDate = new Date(curDate.setMonth(curDate.getMonth() - 1))
      curDate = new Date(curMonthAndYear)
      this.toDate = new Date(curDate.getFullYear(), curDate.getMonth() + 2, 0)
    },
    loadEndDateBasedOnStartingDate (curDate) {
      var curDt = new Date(curDate)
      var date = curDt.getDate()
      if (date === 1) {
        this.lProjBillingBase.billing_end_date = handy.formatDBDate(new Date(curDt.getFullYear(), curDt.getMonth() + 1, 0))
      } else {
        curDt.setDate(date - 1)
        curDt.setMonth(curDt.getMonth() + 1)
        this.lProjBillingBase.billing_end_date = handy.formatDBDate(curDt)
      }
    },
    saveProjectBillingBaseChanges (action) {
      if (!this.lProjBillingBase.proj_billing_base_pair.proj_contract_base_id || !this.lProjBillingBase.billing_monthAndYear || !this.lProjBillingBase.billing_start_date || !this.lProjBillingBase.billing_end_date) {
        this.msg('Please Enter all the fields', 0)
      } else {
        if (this.$refs.pForm.validate()) {
          this.axios.post(config.API_URL + '/projectBillingBase/' + action, this.lProjBillingBase)
          .then(response => {
            if (action === 'create') {
              this.lProjBillingBase.proj_billing_base_id = response.data.proj_billing_base_id
              this.lProjBilling.proj_id = response.data.proj_id
              this.lProjBilling.proj_name = this.lProjBillingBase.proj_billing_base_pair.proj_name
              this.lProjBilling.billing_start_date = new Date(response.data.billing_start_date).toString().substring(4, 10) + ', ' + new Date(response.data.billing_start_date).toString().substring(11, 15)
              this.lProjBilling.billing_end_date = new Date(response.data.billing_end_date).toString().substring(4, 10) + ', ' + new Date(response.data.billing_end_date).toString().substring(11, 15)
              this.lProjBilling.billing_cycle = (new Date(response.data.billing_end_date).getTime() - new Date(response.data.billing_start_date).getTime()) / (1000 * 3600 * 24) + 1
              this.lBillNo = parseInt(response.data.bill_no).toFixed(1)
            }
            this.loadProjectBillingDet()
            this.loadBillHistory(this.lProjBilling.proj_id)
            this.loadProjectBilling()
            this.msg('Saved Successfully', 1)
            this.lAction = 'update'
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      }
    },
    prepareUpdate (curRec) {
      this.lProjBillingBase = Object.assign({}, curRec)
      this.loadProjectFromProjectContractList()
      this.isClosedProject = curRec.proj_status === 'Closed' ? true : false
      this.lProjBilling.proj_id = curRec.proj_id
      this.lProjBillingBase.billing_start_date = curRec.billing_start_date ? handy.formatDBDate(curRec.billing_start_date) : null
      this.lProjBillingBase.billing_end_date = curRec.billing_end_date ? handy.formatDBDate(curRec.billing_end_date) : null
      this.lProjBillingBase.billing_monthAndYear = curRec.billing_year + '-' + curRec.billing_month
      this.basedOnSelectedMonthShowStartingAndEndingDate(this.lProjBillingBase.billing_monthAndYear)
      this.lProjBillingBase.proj_billing_base_pair = { proj_name: this.lProjBillingBase.proj_name, proj_contract_base_id: this.lProjBillingBase.proj_contract_base_id }
      this.lProjBilling.billing_start_date = new Date(curRec.billing_start_date).toString().substring(4, 10) + ', ' + new Date(curRec.billing_start_date).toString().substring(11, 15)
      this.lProjBilling.billing_end_date = new Date(curRec.billing_end_date).toString().substring(4, 10) + ', ' + new Date(curRec.billing_end_date).toString().substring(11, 15)
      this.lProjBilling.billing_cycle = (new Date(curRec.billing_end_date).getTime() - new Date(curRec.billing_start_date).getTime()) / (1000 * 3600 * 24) + 1
      this.lProjBilling.proj_name = this.lProjBillingBase.proj_name
      this.lProjBillingBase.proj_billing_base_id = curRec.proj_billing_base_id
      this.lProjBilling.approved_billed_amt = curRec.approved_billed_amt
      this.lStatus = curRec.billing_status
      this.lBillNo = curRec.bill_no.toFixed(1)
      this.loadBillHistory(this.lProjBilling.proj_id)
      this.loadProjectBillingDet()
      this.lAction = 'update'
    },
    deleteProjectBilling (curBase) {
      if (!confirm('Sure, you want to delete the Project Billing with name "' + curBase.proj_name + '" and Ver "' + this.lBillNo +'" (' + this.lStatus +') ?')) {
        return
      }
      // up in db
      curBase.vendor_id = config.VENDOR_ID
      curBase.proj_contract_base_id = this.lProjBillingBase.proj_billing_base_id
      this.axios.post(config.API_URL + '/projectBillingBase/delete', curBase)
      .then(response => {
        // refresh stats
        this.loadProjectBilling()
        this.lAction = 'view'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjectBillingDet () {
      var qry = {
        params: {
          proj_billing_base_id: this.lProjBillingBase.proj_billing_base_id
        }
      }
      this.totalBillingAmt = {
        tot_chargeable_amt: 0,
        tot_billed_amt: 0,
        total_man_cost: 0,
        total_ser_cost: 0,
        mgmt_fee_amt: 0,
        gst_amt: 0
      }
      this.projBillingDetList = []
      this.axios.get(config.API_URL + '/getListOfProjectBillingDet/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.projBillingDetList = response.data
          for(var i = 0; i < response.data.length; i++) {
            this.totalBillingAmt.tot_chargeable_amt += response.data[i].chargeable_amt
            this.totalBillingAmt.tot_billed_amt += response.data[i].billed_amt
            this.totalBillingAmt.mgmt_fee_amt += response.data[i].Mgmt_fee_amt
            this.totalBillingAmt.gst_amt += response.data[i].gst_amt
            if (response.data[i].proj_billing_staff_det_id && response.data[i].proj_billing_service_det_id === null) {
              this.totalBillingAmt.total_man_cost += response.data[i].billed_amt
            } else if (response.data[i].proj_billing_staff_det_id === null && response.data[i].proj_billing_service_det_id) {
              this.totalBillingAmt.total_ser_cost += response.data[i].billed_amt
            }
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    showClosedProjects () {
      this.isClosedProject = !this.isClosedProject
      this.loadProjectBilling()
    },
    prepareStaffDet (curBaseId) {
      var qry = {
        params: {
          proj_contract_base_id: curBaseId
        }
      }
      this.projContractDetList = []
      this.axios.get(config.API_URL + '/getListOfProjectContractDetailBasedOnGivenBaseId/', qry)
      .then(response => {
        this.projContractDetList = response.data
        this.selected = []
        this.showListOfProjContractDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToProjectBilling (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        var baseId = this.lProjBillingBase.proj_billing_base_pair.proj_contract_base_id
        curSelectedArray.push({
          proj_billing_base_id: this.lProjBillingBase.proj_billing_base_id
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/projectBillingImport/' + baseId, curSelectedArray)
        .then(response => {
          if (response.data === 'Success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfProjContractDet = false
          this.showtoAddExistingBillingDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadBillHistory(this.lProjBilling.proj_id)
            this.loadProjectBillingDet()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select from the given list to import it.', 0)
      }
    },
    loadBillHistory (curProjId) {
      var qry = {
        params: {
          proj_id: curProjId,
          billing_start_date: this.lProjBillingBase.billing_start_date,
          billing_end_date: this.lProjBillingBase.billing_end_date
        }
      }
      this.billNoList = []
      this.lProjBilling.approved_billed_amt = 0
      this.axios.get(config.API_URL + '/getListOfBillNoBasedOnProjId/', qry)
      .then(response => {
        this.billNoList = response.data
        if (response.data.length > 0) {
          this.billNoList.forEach(rec => {
            rec.bill_no = rec.bill_no.toFixed(1)
            if (rec.billing_status === "Approved") {
              this.lProjBilling.approved_billed_amt += rec.tot_billed_amt
            }
          })
          this.lProjBilling.created_by = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].created_by_name
          this.lProjBilling.created_date = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].created_date
          this.lProjBilling.update_by = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].update_by_name
          this.lProjBilling.updated_date = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].updated_date
          this.lProjBilling.approved_by = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].approved_by_name
          this.lProjBilling.approved_date = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].approved_date
          this.lProjBilling.approved_remark = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].approved_remark
          this.lProjBilling.submitted_by_name = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].submitted_by_name
          this.lProjBilling.submitted_date = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].submitted_date
          this.lProjBilling.submitted_remark = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].submitted_remark
          this.lProjBilling.rejected_date = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].rejected_date
          this.lProjBilling.rejected_by_name = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].rejected_by_name
          this.lProjBilling.rejected_remark = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].rejected_remark
          this.lProjBilling.drafted_date = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].drafted_date
          this.lProjBilling.drafted_by_name = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].drafted_by
          this.lProjBilling.drafted_remark = response.data.filter(rec => rec.proj_billing_base_id === this.lProjBillingBase.proj_billing_base_id)[0].drafted_remarks
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdateProjBillingDet (curRec) {
      this.lProjBillingDet = Object.assign({}, curRec)
      this.lProjBillingDet.updated_by = config.EMP_ID
      this.lProjBillingDet.wo = Number(this.lProjBillingDet.wo ? this.lProjBillingDet.wo : 0)
      this.lProjBillingDet.holidays = Number(this.lProjBillingDet.holidays ? this.lProjBillingDet.holidays : 0)
      this.showEditProjectBillingDet = true
    },
    calculateBilledAmtBasedOnPresentdays () {
      this.lProjBillingDet.tot_days_worked = Number(this.lProjBillingDet.present_days) + Number(this.lProjBillingDet.wo) + Number(this.lProjBillingDet.holidays)
      this.lProjBillingDet.billed_amt = Math.round((this.lProjBillingDet.chargeable_amt / this.lProjBillingDet.billing_cycle) * this.lProjBillingDet.tot_days_worked)
    },
    saveUpdatedProjectBillingDetails (curRec) {
      curRec.proj_id = this.lProjBilling.proj_id
      curRec.proj_billing_base_id = this.lProjBillingBase.proj_billing_base_id
      curRec.Mgmt_fee_amt = (curRec.billed_amt * curRec.Mgmt_fee_per) / 100
      curRec.igst_amt = ((((curRec.billed_amt * curRec.Mgmt_fee_per) / 100) + curRec.billed_amt) * curRec.igst_per) / 100
      curRec.cgst_amt = ((((curRec.billed_amt * curRec.Mgmt_fee_per) / 100) + curRec.billed_amt) * curRec.cgst_per) / 100
      curRec.sgst_amt = ((((curRec.billed_amt * curRec.Mgmt_fee_per) / 100) + curRec.billed_amt) * curRec.sgst_per) / 100
      this.axios.post(config.API_URL + '/projectBillingUpdate/update', curRec)
      .then(response => {
        this.loadBillHistory(this.lProjBilling.proj_id)
        this.loadProjectBillingDet()
        this.loadProjectBilling()
        this.msg('Updated Successfully', 1)
        this.showEditProjectBillingDet = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareServiceDet (curBaseId) {
      this.lProjBillingService.action = 'Create'
      this.lAddToExistingProjBillingDet = {
        billing_service_text: '',
        chargeable_amt: '',
        billed_amt: '',
        Mgmt_fee_per: null,
        Mgmt_fee_amt: 0,
        is_igst: null,
        igst_per: 18,
        igst_amt: 0,
        cgst_per: 9,
        cgst_amt: 0,
        sgst_per: 9,
        sgst_amt: 0
      }
      var qry = {
        params: {
          proj_contract_base_id: this.lProjBillingBase.proj_billing_base_pair.proj_contract_base_id
        }
      }
      this.projContractDetList = []
      this.axios.get(config.API_URL + '/getListOfProjectContractServiceDetailBasedOnGivenBaseId/', qry)
      .then(response => {
        this.projContractServiceDetList = response.data
        this.selected = []
        this.loadProjContractService()
        this.showtoAddExistingBillingDet = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    calculateTotalGstAmt (curRec) {
      curRec.Mgmt_fee_amt = parseInt(curRec.chargeable_amt) * (curRec.Mgmt_fee_per / 100)
      if (curRec.is_igst) {
        curRec.igst_amt = (parseInt(curRec.chargeable_amt) + curRec.Mgmt_fee_amt) * (curRec.igst_per / 100)
        curRec.cgst_amt = 0
        curRec.sgst_amt = 0
      } else {
        curRec.cgst_amt = (parseInt(curRec.chargeable_amt) + curRec.Mgmt_fee_amt) * (curRec.cgst_per / 100)
        curRec.sgst_amt = (parseInt(curRec.chargeable_amt) + curRec.Mgmt_fee_amt) * (curRec.sgst_per / 100)
        curRec.igst_amt = 0
      }
      curRec.billed_amt = parseInt(curRec.chargeable_amt)
    },
    deleteDetail (curDetRec) {
      if (!confirm('Sure, you want to delete the Details with role name "' + curDetRec.staff_role + '"?')) {
        return
      }
      // up in db
      this.axios.post(config.API_URL + '/projectBillingUpdate/delete', curDetRec)
      .then(response => {
        // refresh stats
        this.loadBillHistory(this.lProjBilling.proj_id)
        this.loadProjectBillingDet()
        this.loadProjectBilling()
        this.showDet = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    saveServiceProjectBillingDetails (curserviceDet, action) {
      // curserviceDet.proj_contract_sub_cat_id = this.lProjBillingService.proj_contract_sub_cat_id
      curserviceDet.updated_by = config.EMP_ID
      if (curserviceDet.is_igst) {
        curserviceDet.cgst_per = 0
        curserviceDet.sgst_per = 0
      } else {
        curserviceDet.igst_per = 0
      }
      curserviceDet.proj_billing_base_id = this.lProjBillingBase.proj_billing_base_id
      this.axios.post(config.API_URL + '/addServiceDetails/' + action, curserviceDet)
      .then(response => {
        this.loadBillHistory(this.lProjBilling.proj_id)
        this.loadProjectBillingDet()
        this.loadProjectBilling()
        this.msg('Saved Successfully', 1)
        this.showtoAddExistingBillingDet = false
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareNewBill (curBase) {
      curBase.created_by = config.EMP_ID
      this.axios.post(config.API_URL + '/projectBillingBase/create', curBase)
      .then(response => {
        this.lProjBillingBase.proj_billing_base_id = response.data.proj_billing_base_id
        this.lProjBilling.proj_id = response.data.proj_id
        this.lProjBilling.proj_name = this.lProjBillingBase.proj_billing_base_pair.proj_name
        this.lBillNo = response.data.bill_no.toFixed(1)
        this.lStatus = 'Draft'
        this.loadProjectBillingDet()
        this.loadBillHistory(this.lProjBilling.proj_id)
        this.msg('Saved Successfully', 1)
        this.lAction = 'update'
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareProjectBillingStatus (curBase, status) {
      this.lProjBillingStatus = Object.assign({}, curBase)
      this.lProjBillingStatus.approve_remarks = ''
      this.lProjBillingStatus.submit_remarks = ''
      this.lProjBillingStatus.rejected_remark = ''
      this.lProjBillingStatus.drafted_remarks = ''
      this.lProjBillingStatus.status = status
      this.showCommentDlg = true
    },
    statusChangeTheProjectContract(curBase, status) {
      var idx = -1
      if (status === "Submitted") {
        idx = this.billNoList.findIndex(rec => rec.billing_status === status && rec.bill_no.includes(this.lBillNo.split('.')[0]))
      }
      if (idx > -1) {
        this.msg('Only one Submitted version is allowed for one Version', 0)
      } else {
        if (!confirm('Sure, you want to change the Status to "' + status + ' ?"')) {
          return
        }
        // up in db
        curBase.vendor_id = config.VENDOR_ID
        curBase.status = status
        if (status === 'Submitted') {
          curBase.submitted_by = config.EMP_ID
          curBase.approved_by = null
          curBase.approved_date = null
        } else if (status === 'Approved') {
          curBase.approved_by = config.EMP_ID
        } else if (status === "Draft") {
          curBase.drafted_by = config.EMP_ID
        } else {
          curBase.rejected_by = config.EMP_ID
        }
        curBase.proj_billing_base_id = this.lProjBillingBase.proj_billing_base_id
        curBase.bill_no = this.lBillNo.split('.')[0]
        this.axios.post(config.API_URL + '/projectBillingBase/status', curBase)
        .then(response => {
          if (status === "Rejected") {
            this.lStatus = "Draft"
          } else {
            this.lStatus = status
          }
          this.loadBillHistory(this.lProjBilling.proj_id)
          this.loadProjectBillingDet()
          this.loadProjectBilling()
          this.msg('Saved Successfully', 1)
          this.showCommentDlg = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadBillingDetailsBasedOnBillNo (curRec) {
      this.lBillNo = curRec.bill_no
      this.lStatus = curRec.billing_status
      this.lProjBilling.update_by = curRec.update_by_name
      this.lProjBilling.updated_date = curRec.updated_date
      this.lProjBilling.approved_by_name = curRec.approved_by_name
      this.lProjBilling.rejected_by_name = curRec.rejected_by_name
      this.lProjBilling.submitted_by_name = curRec.submitted_by_name
      this.lProjBilling.submitted_date = curRec.submitted_date
      this.lProjBilling.approved_date = curRec.approved_date
      this.lProjBilling.rejected_date = curRec.rejected_date
      this.lProjBillingBase.proj_billing_base_id = curRec.proj_billing_base_id
      this.loadProjectBillingDet()
    },
    prepareRevision (curRec) {
      curRec.emp_id = config.EMP_ID
      curRec.vendor_id = config.VENDOR_ID
      curRec.proj_id = this.lProjBilling.proj_id
      curRec.proj_contract_base_id = this.lProjBillingBase.proj_billing_base_pair.proj_contract_base_id
      curRec.proj_billing_base_id = this.lProjBillingBase.proj_billing_base_id
      curRec.bill_no_prm = this.lBillNo.substring(0, 2) + '%'
      this.axios.post(config.API_URL + '/projectBillingUpdate/projBillingRevision', curRec)
      .then(response => {
        this.lProjBillingBase.proj_billing_base_id = response.data.proj_billing_base_id
        this.lProjBilling.proj_id = response.data.proj_id
        this.lStatus = response.data.billing_status
        this.lBillNo = response.data.bill_no.toFixed(1)
        this.lProjBilling.submitted_by_name = ''
        this.loadProjectBillingDet()
        this.loadBillHistory(response.data.proj_id)
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareViewProjBilling (curRec) {
      var qry = {
        params: {
          proj_billing_base_id: curRec.proj_billing_base_id
        }
      }
      this.projBillingView = []
      this.axios.get(config.API_URL + '/getProjBillingViewAsPdf/', qry)
      .then(response => {
        if (response.data.length) {
          response.data.forEach(rec => {
            if (rec.staff_role === 'GST' && rec.is_igst === 0) {
              this.projBillingView.push({
                proj_billing_service_det_id: rec.proj_billing_service_det_id,
                proj_billing_staff_det_id: rec.proj_billing_staff_det_id,
                staff_role: 'CGST',
                head_count: rec.head_count,
                billing_cycle: rec.billing_cycle,
                present_days: rec.present_days,
                wo: rec.wo,
                holidays: rec.holidays,
                tot_days_worked: rec.tot_days_worked,
                chargeable_amt: rec.chargeable_amt,
                is_igst: rec.is_igst,
                billed_amt: rec.billed_amt
              })
              this.projBillingView.push({
                proj_billing_service_det_id: rec.proj_billing_service_det_id,
                proj_billing_staff_det_id: rec.proj_billing_staff_det_id,
                staff_role: 'SGST',
                head_count: rec.head_count,
                billing_cycle: rec.billing_cycle,
                present_days: rec.present_days,
                wo: rec.wo,
                holidays: rec.holidays,
                tot_days_worked: rec.tot_days_worked,
                chargeable_amt: rec.chargeable_amt,
                is_igst: rec.is_igst,
                billed_amt: rec.billed_amt
              })
            } else if (rec.staff_role === 'GST' && rec.is_igst === 1) {
              this.projBillingView.push({
                proj_billing_service_det_id: rec.proj_billing_service_det_id,
                proj_billing_staff_det_id: rec.proj_billing_staff_det_id,
                staff_role: 'IGST',
                head_count: rec.head_count,
                billing_cycle: rec.billing_cycle,
                present_days: rec.present_days,
                wo: rec.wo,
                holidays: rec.holidays,
                tot_days_worked: rec.tot_days_worked,
                chargeable_amt: rec.chargeable_amt,
                is_igst: rec.is_igst,
                billed_amt: rec.billed_amt
              })
            } else {
              this.projBillingView.push({
                proj_billing_service_det_id: rec.proj_billing_service_det_id,
                proj_billing_staff_det_id: rec.proj_billing_staff_det_id,
                staff_role: rec.staff_role,
                head_count: rec.head_count,
                billing_cycle: rec.billing_cycle,
                present_days: rec.present_days,
                wo: rec.wo,
                holidays: rec.holidays,
                tot_days_worked: rec.tot_days_worked,
                chargeable_amt: rec.chargeable_amt,
                is_igst: rec.is_igst,
                billed_amt: rec.billed_amt
              })
            }
          })
        }
        this.showViewAsPdf = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    changeView (curTab) {
      if (curTab === 'Proposal breakup') {
        this.attTab = 'tab-0'
      } else if (curTab === 'end-to-end proposal') {
        this.attTab = 'tab-1'
      } else if (curTab === 'compressed view') {
        this.attTab = 'tab-2'
      } else {
        this.attTab = 'tab-3'
      }
    },
    prepareViewProjContract (curContractId) {
      var qry = {
        params: {
          proj_contract_base_id: curContractId
        }
      }
      this.axios.get(config.API_URL + '/getProjContractViewAsPdf/', qry)
      .then(response => {
        this.projContractView = response.data
        this.projContractView.forEach(rec => {
          if (rec.length) {
            if (!rec.total_amount) {
              rec.total_amount = 0
            }
            if (!rec.gst_amt || !rec.before_gst) {
              rec.gst_tax_amt = 0
              rec.tax_amt = 0
              rec.before_gst = 0
            }
            if (!rec.mgmt) {
              rec.mgmt = 0
            }
            rec.forEach(records => {
              if (records.amount) {
                rec.total_amount += records.amount
              }
              if (records.total_hc_amt) {
                rec.total_amount += records.total_hc_amt
              }
              rec.mgmt += records.Mgmt_fee_amt
              rec.tax_amt += records.tax_amt
              rec.before_gst = rec.total_amount + rec.mgmt
              rec.gst_tax_amt = rec.before_gst + rec.tax_amt
            })
          }
        })
        this.showContractViewAsPdf = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareFilter () {
      this.loadProjectFromProjectContractList()
      this.filterList = this.getEmptyFilter()
      this.showFilter = true
    },
    getEmptyFilter () {
      var filter = {
        proj_contract_base_id: [],
        billing_monthAndYear: null
      }
      return filter
    },
    clearFilter () {
      this.filterList.proj_contract_base_id = []
      this.filterList.billing_monthAndYear = null
      this.loadProjectBilling()
      this.showFilter = false
      this.$forceUpdate()
    },
    applyFilter () {
      this.filterList.billing_year = this.filterList.billing_monthAndYear.split('-')[0]
      this.filterList.billing_month = this.filterList.billing_monthAndYear.split('-')[1]
      setTimeout(() => {
        this.loadProjectBilling()
      }, 1000)
      this.showFilter = false
    },
    loadProjContractService () {
      var qry = {
        params: {
          proj_contract_base_id: this.lProjBillingBase.proj_billing_base_pair.proj_contract_base_id
        }
      }
      this.axios.get(config.API_URL + '/getListOfServicesBasedOnProjContractId/', qry)
      .then(response => {
        this.contractServiceList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdateServiceProjBillingDet (curRec) {
      this.loadProjContractService()
      this.lAddToExistingProjBillingDet = Object.assign({}, curRec)
      this.lAddToExistingProjBillingDet.updated_by = config.EMP_ID
      this.lAddToExistingProjBillingDet.billing_service_text = curRec.staff_role
      if (this.lAddToExistingProjBillingDet.is_igst) {
        this.lAddToExistingProjBillingDet.cgst_amt = 0
        this.lAddToExistingProjBillingDet.cgst_per = 0
        this.lAddToExistingProjBillingDet.sgst_amt = 0
        this.lAddToExistingProjBillingDet.sgst_per = 0
      } else {
        this.lAddToExistingProjBillingDet.igst_per = 0
        this.lAddToExistingProjBillingDet.igst_amt = 0
      }
      this.lProjBillingService.category = 'Add new Services'
      this.lProjBillingService.action = 'Update'
      this.showtoAddExistingBillingDet = true
    },
    loadBillingComparison () {
      this.lProjBillingBase.billing_monthAndYear = this.lProjBillingBase.billing_monthAndYear.replace('-', '/')
      var curDate = new Date(this.lProjBillingBase.billing_monthAndYear + '/1')
      curDate.setDate(1)
      var qry = {
        params: {
          proj_id: this.lProjBillingBase.proj_id,
          vendor_id: config.VENDOR_ID,
          previous_month: new Date(curDate).getMonth() === 0 ? 12 : new Date(curDate).getMonth(),
          previous_year: new Date(curDate).getMonth() === 0 ? new Date(curDate).getFullYear() - 1 : new Date(curDate).getFullYear(),
          current_month: parseInt(this.lProjBillingBase.billing_monthAndYear.split('/')[1]),
          current_year: parseInt(this.lProjBillingBase.billing_monthAndYear.split('/')[0]),
          next_month: parseInt(this.lProjBillingBase.billing_monthAndYear.split('/')[1]) === 12 ? 1 : parseInt(this.lProjBillingBase.billing_monthAndYear.split('/')[1]) + 1,
          next_year: parseInt(this.lProjBillingBase.billing_monthAndYear.split('/')[1]) === 12 ? new Date(curDate).getFullYear() + 1 : new Date(curDate).getFullYear()
        }
      }
      var tmpVar = {
        staff_role: '',
        role_id: null,
        previous_month_billed_amt: 0,
        current_month_billed_amt: 0,
        next_month_billed_amt: 0,
        first_comparison: 0,
        sec_comparison: 0,
      }
      this.comparisonDataList = []
      this.axios.get(config.API_URL + '/getSelectedMonthComparisonBillingDataBasedOnProjId/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.comparisonDataList = response.data
          for (var i = 1; i < response.data.length; i++) {
            tmpVar.previous_month_billed_amt += parseInt(response.data[i].previous_month_billed_amt)
            tmpVar.current_month_billed_amt += parseInt(response.data[i].current_month_billed_amt)
            tmpVar.next_month_billed_amt += parseInt(response.data[i].next_month_billed_amt)
            tmpVar.first_comparison += parseInt(response.data[i].first_comparison)
            tmpVar.sec_comparison += parseInt(response.data[i].sec_comparison)
          }
          this.comparisonDataList.push({
            staff_role: 'Total',
            role_id: null,
            previous_month_billed_amt: tmpVar.previous_month_billed_amt,
            current_month_billed_amt: tmpVar.current_month_billed_amt,
            next_month_billed_amt: tmpVar.next_month_billed_amt,
            first_comparison: tmpVar.first_comparison,
            sec_comparison: tmpVar.sec_comparison,
          })
          this.projectBill.proj_name = this.lProjBillingBase.proj_name
          this.projectBill.prev_comp = ((tmpVar.current_month_billed_amt / tmpVar.previous_month_billed_amt) * 100).toFixed(2)
          this.projectBill.next_comp = ((tmpVar.current_month_billed_amt / tmpVar.next_month_billed_amt) * 100).toFixed(2)
          this.projectBill.prev_month = this.comparisonDataList[0].previous_month_billed_amt
          this.projectBill.next_month = this.comparisonDataList[0].next_month_billed_amt
          this.projectBill.current_month = this.comparisonDataList[0].current_month_billed_amt
          this.projectBill.previous_month_billed_amt = tmpVar.previous_month_billed_amt
          this.projectBill.current_month_billed_amt = tmpVar.current_month_billed_amt
          this.projectBill.next_month_billed_amt = tmpVar.next_month_billed_amt
        } else {
          this.comparisonDataList = []
        }
        this.showComparisonData = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>
